export { default } from './auth-service'



// WEBPACK FOOTER //
// ./src/services/auth/index.js